<template>
  <div class="content-dashboard">
    <div class="d-flex justify-content-between align-items-center">
      <div class="d-flex align-items-center gap-3">
        <h3>Catalogue</h3>
      </div>
      <button v-if="productNotifications.length > 0" class="btn-notif-new d-flex align-items-center gap-3" @click="showNewProductsModal = true">
        <i class="ti ti-bell-ringing-2 fs-4"></i>
        <span class="text-start">
          {{ productNotifications.length === 1 ? 'Un nouveau produit a été ajouté' : 'De nouveaux produits ont été ajoutés' }}<br>
          à votre catalogue !
        </span>
      </button>
    </div>

    <div class="row mt-3">
      <div class="col-lg-12">
        <div class="box-chart mb-3 w-100 p-4">
          <div class="d-flex gap-0 justify-content-between align-items-center">
            <div class="gamme-info gamme-catalogue w-30">
              <h3 class="dark-color mb-2">Gamme en vente</h3>
              <p>Configurer les gammes à mettre en ligne sur la plateforme en vente</p>
            </div>

            <div v-if="loading || registerLoading || saving || priceCoefsLoading || !initializationComplete" class="text-center">
              <p>{{ saving ? "Enregistrement en cours..." : "Chargement des données..." }}</p>
            </div>
            <div v-else-if="error || registerError || saveError || priceCoefsError" class="text-danger">
              <p>{{ error || registerError || saveError || priceCoefsError }}</p>
            </div>
            <div v-else-if="gammes.length === 0" class="text-center">
              <p>Aucune gamme disponible</p>
            </div>
            <div v-else class="check-block d-flex gap-3">
              <label
                v-for="gamme in gammes"
                :key="gamme._custom?.value?.id || gamme.id"
                :class="['check-button', { active: selected.includes(gamme._custom?.value?.name || gamme.name) }]"
              >
                <input type="checkbox" :value="gamme._custom?.value?.name || gamme.name" v-model="selected" hidden />
                <span class="label-text">
                  {{ (gamme._custom?.value?.name || gamme.name || "Nom inconnu").replace(/^Gamme\s+/i, "").trim() }}
                </span>
                <span class="check-icon" v-if="selected.includes(gamme._custom?.value?.name || gamme.name)">
                  <i class="ti ti-check-box ps-2"></i>
                </span>
              </label>
            </div>

            <button class="btn btn-orange w-15" :disabled="saving || !initializationComplete" @click="saveGammes">Enregistrer</button>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-lg-12">
        <div class="box-chart mb-3 w-100 p-4">
          <div class="col-lg-12 d-flex justify-content-between align-items-center">
            <div class="d-flex gap-3">
              <div class="input-form">
                <label class="label-control">Rechercher un article</label>
                <input type="text" class="form-control" v-model="searchQuery" placeholder="Rechercher par nom..." />
              </div>
              <!-- Gamme Filter -->
              <div class="input-form">
                <label class="label-control">Filtrer par Espèce</label>
                <select class="form-control" v-model="selectedGamme" @change="onGammeChange">
                  <option value="">Toutes les Espèces</option>
                  <option v-for="gamme in availableGammes" :key="gamme._custom?.value?.code || gamme.code" :value="gamme._custom?.value?.name || gamme.name">
                    {{ (gamme._custom?.value?.name || gamme.name).replace(/^Gamme\s+/i, "").trim() }}
                  </option>
                </select>
              </div>
              <!-- Sous-gamme Filter -->
              <div class="input-form" v-if="selectedGamme && availableSousGammes.length > 0">
                <label class="label-control">Filtrer par gamme</label>
                <select class="form-control" v-model="selectedSousGamme" @change="onSousGammeChange">
                  <option value="">Toutes les gammes</option>
                  <option v-for="sousGamme in availableSousGammes" :key="sousGamme._custom?.value?.code || sousGamme.code" :value="sousGamme._custom?.value?.name || sousGamme.name">
                    {{ (sousGamme._custom?.value?.name || sousGamme.name).replace(/^Gamme\s+/i, "").trim() }}
                  </option>
                </select>
              </div>
            </div>
            <button class="btn btn-orange" @click="downloadExcel">Télécharger mes tarifs</button>
          </div>
          <div class="d-flex justify-content-between align-items-center mt-4 mb-4">
            <div class="gamme-info w-50">
              <h3 class="dark-color">Paramétrer mes prix de vente par article</h3>
              <p class="blue-color">
                Vous pouvez librement personnaliser vos tarifs article par article ou décider d'appliquer le prix public
                conseillé en cliquant sur le bouton ci-après
              </p>
            </div>

            <div class="check-input d-flex">
              <label class="check-button" :class="{ active: isChecked }">
                <input type="checkbox" v-model="isChecked" hidden :disabled="isChecked" @change="handleRecommendedPriceToggle" />
                <span class="label-text">Appliquer le prix de revente conseillé pour tout mon catalogue</span>
                <span class="check-icon" v-if="isChecked">
                  <i class="ti ti-check-box ps-2"></i>
                </span>
              </label>
            </div>
          </div>

          <div class="table-responsive mt-4">
            <table class="table table-style-1" ref="priceTable">
              <thead>
                <tr>
                  <th class="w-5">
                    <!-- Modified indicator column -->
                  </th>
                  <th>
                    <div class="table-header-with-sort">
                      <span class="header-title">Articles</span>
                      <button 
                        class="btn-sort" 
                        :class="{
                          'sort-active': sortActive,
                          'sort-asc': sortActive && sortAscending,
                          'sort-desc': sortActive && !sortAscending
                        }"
                        @click="toggleSortArticles"
                        :title="getSortTooltip"
                      >
                        <i 
                          class="ti sort-icon" 
                          :class="{
                            'fa-solid fa-arrow-up': sortAscending && sortActive,
                            'fa-solid fa-arrow-down': !sortAscending && sortActive,
                            'fa-solid fa-sort': !sortActive
                            
                          }"
                        ></i>
                        <span class="sort-order" v-if="sortActive">
                          {{ sortAscending ? 'A-Z' : 'Z-A' }}
                        </span>
                      </button>
                    </div>
                  </th>
                  <th><strong>Prix d'achat</strong></th>
                  <th><strong>Coef de marge</strong></th>
                  <th><strong>Prix de vente H.T</strong></th>
                  <th><strong>TVA</strong></th>
                  <th><strong>Prix de vente TTC</strong></th>
                  <th><strong>Actions</strong></th>
                </tr>
              </thead>
              <tbody>
                <!-- Show loader when priceCoefsLoading is true -->
                <tr v-if="priceCoefsLoading">
                  <td colspan="8" class="text-center">
                    <div class="spinner-circle-small"></div>
                    <p>Chargement des articles...</p>
                  </td>
                </tr>
                <!-- Show table content when not loading -->
                <template v-else>
                  <tr 
                    v-for="(article, filteredIndex) in filteredAndSortedPriceCoefs" 
                    :key="article.id"
                    :class="{ 'modified': isArticleModified(article.id) }"
                  >
                    <td class="w-5">
                      <div class="modified-indicator" v-if="isArticleModified(article.id)">
                        <i class="ti ti-circle-filled text-warning"></i>
                      </div>
                    </td>
                    <td class="w-25">
                      <div class="article-name-cell">
                        {{ article.productName || "Chargement..." }}
                        <span v-if="formatUnity(article.unity)" class="unity-badge">
                      <span class="small-x">x</span>{{ formatUnity(article.unity) }}
                    </span>
                      </div>
                    </td>
                    <td>{{ article.prixAchat || "N/A" }}</td>
                    <td class="w-15">
                      <input 
                        type="text" 
                        class="form-control" 
                        v-model="article.coef" 
                        @input="onArticleInput(article.id, 'coef', $event)"
                      />
                    </td>
                    <td class="w-15">
                      <input
                        type="text"
                        class="form-control"
                        v-model="article.prixVenteHT"
                        @input="onArticleInput(article.id, 'prixVenteHT', $event)"
                      />
                    </td>
                    <td>{{ article.tva || "N/A" }}</td>
                    <td>{{ article.prixTTC || "N/A" }}</td>
                    <td>
                      <button 
                        class="btn-save" 
                        :disabled="!isArticleModified(article.id) || savingSingle.has(article.id)"
                        @click="saveArticlePrice(filteredIndex)"
                      >
                        <i class="ti ti-save"></i>
                        <span class="spinner-circle-small white ms-1" v-if="savingSingle.has(article.id)"></span>
                      </button>
                    </td>
                  </tr>
                  <tr v-if="filteredAndSortedPriceCoefs.length === 0 && !priceCoefsError">
                    <td colspan="8" class="text-center">Aucun article correspondant aux critères</td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- Sticky Save Multiple Button -->
    <div 
      class="sticky-save-multiple" 
      :class="{ 'has-changes': hasModifiedArticles }"
    >
      <button 
        class="btn btn btn-orange  btn-orange-sticky" 
        :disabled="savingMultiple || !hasModifiedArticles"
        @click="saveMultipleArticles"
      >
        <span v-if="savingMultiple">
          <span class="spinner-circle-small white me-2"></span>
          Enregistrement en cours...
        </span>
        <span v-else>
          <i class="ti ti-save me-2"></i>
          Enregistrer les modifications ({{ modifiedArticlesCount }})
        </span>
      </button>
    </div>

    <div class="modal fade" id="ModalCatalogue" tabindex="-1" aria-labelledby="modalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered max-width-65">
        <div class="modal-content">
          <div class="modal-header justify-content-end">
            <button type="button" class="close-link" data-bs-dismiss="modal" aria-label="Fermer">
              <i class="ti ti-close"></i>
            </button>
          </div>
          <div class="modal-body padd-modal">
            <h3>1 article sur 4 à renseigner</h3>

            <form class="mt-5">
              <div class="form-style-1">
                <h4>Vérifier et confirmer les prix avant de le publier sur le site</h4>

                <div class="d-flex gap-3 mt-4">
                  <div class="input-form">
                    <label class="label-control">Prix d'achat</label>
                    <input type="text" class="form-control" placeholder="44,00 €" />
                  </div>
                  <div class="input-form">
                    <label class="label-control">Prix de vente HT</label>
                    <input type="text" class="form-control" placeholder="44,00 €" />
                  </div>
                </div>

                <div class="d-flex gap-3">
                  <div class="input-form">
                    <label class="label-control">Coef de marge</label>
                    <input type="text" class="form-control" placeholder="22" />
                  </div>
                  <div class="input-form">
                    <label class="label-control">Prix vente TTC</label>
                    <input type="text" class="form-control" placeholder="120,00 €" />
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-between mt-4">
                <div class="check-input d-flex">
                  <label class="check-button" :class="{ active: isChecked }">
                    <input type="checkbox" v-model="isChecked" hidden />
                    <span class="label-text">Appliquer le prix de revente conseillé pour tout mon catalogue</span>
                    <span class="check-icon" v-if="isChecked">
                      <i class="ti ti-check-box ps-2"></i>
                    </span>
                  </label>
                </div>
                <button class="btn btn-orange w-30">Valider</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="showConfirmModal"
      class="modal fade show"
      id="ConfirmPriceModal"
      tabindex="-1"
      aria-labelledby="confirmPriceModalLabel"
      aria-hidden="true"
      style="display: block; background: rgba(0, 0, 0, 0.5)"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header justify-content-end">
            <button type="button" class="close-link" @click="showConfirmModal = false" aria-label="Fermer">
              <i class="ti ti-close"></i>
            </button>
          </div>
          <div class="modal-body">
            <h4>Confirmation</h4>
            <p>Le prix conseillé est appliqué. Êtes-vous sûr de vouloir continuer ?</p>
            <div class="d-flex justify-content-between mt-4">
              <button class="btn btn-outline-secondary" @click="showConfirmModal = false">Annuler</button>
              <button class="btn btn-orange" @click="confirmPriceChange">Continuer</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="showRecommendedPriceModal"
      class="modal fade show"
      id="ConfirmRecommendedPriceModal"
      tabindex="-1"
      aria-labelledby="confirmRecommendedPriceModalLabel"
      aria-hidden="true"
      style="display: block; background: rgba(0, 0, 0, 0.5)"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header justify-content-end">
            <button type="button" class="close-link" @click="closeRecommendedPriceModal" aria-label="Fermer">
              <i class="ti ti-close"></i>
            </button>
          </div>
          <div class="modal-body">
            <h4>Alerte</h4>
            <p>Vous souhaitez écraser tous les prix paramétrés. Êtes-vous sûr de vouloir continuer ?</p>
            <div class="d-flex justify-content-between mt-4">
              <button class="btn btn-outline-secondary" @click="closeRecommendedPriceModal">Non</button>
              <button class="btn btn-orange" @click="confirmRecommendedPrice">
                Oui <span class="spinner-circle-small white ms-1" v-if="saving"></span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <NewProductsModal 
      :show="showNewProductsModal" 
      :products="productNotifications" 
      @close="showNewProductsModal = false" 
      @confirm="handleConfirmNotification"
    />
  </div>
</template>

<script>
import notif from "@/assets/images/bell-notif.svg";
import { ref, watch, computed, onMounted } from "vue";
import NewProductsModal from "@/components/supplyvet/NewProductsModal.vue";
import { useGammesStore } from "@/stores/gammesStore";
import { useRegisterStore } from "@/stores/register";
import { storeToRefs } from "pinia";
import {
  updateVeterinaireSubscription,
  fetchProductVariantPriceCoefs,
  updateProductVariantPriceCoef,
  applyRecommendedPrices,
  fetchNewProductNotifications,
  confirmProductVariantNotification,
} from "@/api/veterinaireService";
import { useToast } from "vue-toastification";
import * as XLSX from "xlsx";

export default {
  name: "CatalogueView",
  components: {
    NewProductsModal
  },
  setup() {
    const toast = useToast();
    const gammesStore = useGammesStore();
    const registerStore = useRegisterStore();
    const { gammes, loading, error } = storeToRefs(gammesStore);
    const { VeterinaireData, loading: registerLoading, error: registerError } = storeToRefs(registerStore);
    
    const saving = ref(false);
    const saveError = ref(null);
    const priceCoefs = ref([]);
    const originalPriceCoefs = ref(new Map()); // Store original values for comparison
    const priceCoefsLoading = ref(false);
    const priceCoefsError = ref(null);
    const isChecked = ref(false);
    const priceTable = ref(null);
    const selectedArticleIndex = ref(null);
    const showConfirmModal = ref(false);
    const showRecommendedPriceModal = ref(false);
    const selectedGamme = ref("");
    const selectedSousGamme = ref("");
    const searchQuery = ref("");
    const selected = ref([]);
    const initializationComplete = ref(false);
    const showNewProductsModal = ref(false);
    const productNotifications = ref([]);

    const fetchNotifications = async () => {
      try {
        const notifications = await fetchNewProductNotifications();
        // Map API data to the format expected by the modal if needed
        productNotifications.value = notifications.map(notif => {
          const variant = notif.productVariant;
          const pricing = variant?.currentChannelPricings;
          
          const prixAchat = notif.prixAchatHt || (pricing?.price ? pricing.price / 100 : 0);
          const recommendedPrice = notif.prixVenteConseilleHt || pricing?.recommendedPrice || 0;
          const tva = (parseFloat(notif.taxAmount) || 0) / 100 || 0.20;
          
          // Initial logic will be handled inside the modal for better state management
          return {
            id: notif.id,
            variantId: variant?.id,
            image: variant?.product?.variant?.imagesProduct?.[0]?.path,
            category: variant?.product?.gamme || "CROQUETTES MÉDICALISÉES",
            name: variant?.product?.name || variant?.product?.inventoryName || "Produit inconnu",
            ref: variant?.code || "N/A",
            description: variant?.product?.shortDescription || "",
            prixAchat: prixAchat,
            recommendedPrice: recommendedPrice,
            tva: tva,
            coef: 0, 
            prixVenteHT: 0,
            prixTTC: 0
          };
        });
      } catch (err) {
        console.error("Error fetching notifications:", err);
      }
    };

    const handleConfirmNotification = async ({ id, payload }) => {
      try {
        await confirmProductVariantNotification(id, payload);
        toast.success("Notification confirmée !");
        // Remove from local list
        productNotifications.value = productNotifications.value.filter(n => n.id !== id);
        // Refresh the catalogue list
        await fetchPriceCoefs();
      } catch (err) {
        toast.error("Erreur lors de la confirmation : " + (err.message || err));
      }
    };
    
    // Modified articles tracking
    const modifiedArticles = ref(new Set());
    const savingMultiple = ref(false);
    const savingSingle = ref(new Set()); // Track individual article saves
    
    // Sorting functionality
    const sortAscending = ref(true); // true for A-Z, false for Z-A
    const sortActive = ref(false); // Track if sorting is active

    // Computed property for sort tooltip
    const getSortTooltip = computed(() => {
      if (!sortActive.value) {
        return "Trier par ordre alphabétique";
      }
      return sortAscending.value ? "Trier Z-A" : "Trier A-Z";
    });

    // Computed properties for modified articles
    const hasModifiedArticles = computed(() => {
      return modifiedArticles.value.size > 0;
    });

    const modifiedArticlesCount = computed(() => {
      return modifiedArticles.value.size;
    });

    // Computed properties for available gammes and sous-gammes
    const availableGammes = computed(() => {
      return gammes.value.filter(gamme => {
        const name = gamme._custom?.value?.name || gamme.name;
        return selected.value.includes(name);
      });
    });

    const availableSousGammes = computed(() => {
      if (!selectedGamme.value) return [];
      
      const selectedGammeObj = availableGammes.value.find(gamme => {
        const name = gamme._custom?.value?.name || gamme.name;
        return name === selectedGamme.value;
      });
      
      return selectedGammeObj?.childrenDetails || [];
    });

    // Filtered articles
    const filteredPriceCoefs = computed(() => {
      return priceCoefs.value.filter(article => {
        const matchesSearch = searchQuery.value
          ? article.productName.toLowerCase().includes(searchQuery.value.toLowerCase())
          : true;
        return matchesSearch;
      });
    });

    // Sorted and filtered articles
    const filteredAndSortedPriceCoefs = computed(() => {
      const filtered = [...filteredPriceCoefs.value];
      
      // Only sort if sort is active
      if (!sortActive.value) {
        return filtered;
      }
      
      return filtered.sort((a, b) => {
        const nameA = (a.productName || '').toLowerCase();
        const nameB = (b.productName || '').toLowerCase();
        
        if (sortAscending.value) {
          return nameA.localeCompare(nameB, 'fr');
        } else {
          return nameB.localeCompare(nameA, 'fr');
        }
      });
    });

    // Initialize selected gammes when both gammes and VeterinaireData are loaded
    const initializeSelectedGammes = () => {
      if (gammes.value.length && VeterinaireData.value?.hasSubscription?.GammeEnVente && !initializationComplete.value) {
        console.log('Initializing gammes selection...');
        console.log('Available gammes:', gammes.value);
        console.log('Veterinaire data:', VeterinaireData.value.hasSubscription.GammeEnVente);
        
        const gammeEnVenteCodes = VeterinaireData.value.hasSubscription.GammeEnVente.map(path =>
          path.split("/").pop()
        );
        
        console.log('Gamme codes from subscription:', gammeEnVenteCodes);
        
        selected.value = gammes.value
          .filter(gamme => {
            const code = gamme._custom?.value?.code || gamme.code;
            const name = gamme._custom?.value?.name || gamme.name;
            console.log(`Checking gamme: ${name} (code: ${code})`);
            return code && gammeEnVenteCodes.includes(code);
          })
          .map(gamme => gamme._custom?.value?.name || gamme.name || "Nom inconnu");
        
        console.log('Selected gammes after initialization:', selected.value);
        initializationComplete.value = true;
      }
    };

    // Watch for both gammes and VeterinaireData to be loaded
    watch(
      [gammes, VeterinaireData],
      () => {
        console.log('Gammes or VeterinaireData changed, initializing...');
        initializeSelectedGammes();
      },
      { immediate: true, deep: true }
    );

    // Reset sorting when filters change to avoid confusion
    watch([selectedGamme, selectedSousGamme, searchQuery], () => {
      sortActive.value = false;
    });

    // Also initialize on component mount with a small delay
    onMounted(() => {
      setTimeout(() => {
        console.log('Component mounted, final initialization attempt...');
        initializeSelectedGammes();
      }, 500);
    });

    watch(
      () => VeterinaireData.value,
      newData => {
        if (newData?.hasSubscription?.prixconseille) {
          isChecked.value = true;
        }
      },
      { immediate: true }
    );

    const fetchPriceCoefs = async (code = null) => {
      priceCoefsLoading.value = true;
      priceCoefsError.value = null;
      try {
        const data = await fetchProductVariantPriceCoefs(code);

        const coefs = await Promise.all(
          data.map(async item => {
            let productName = "Chargement...";
            try {
              productName =
                `${item.productVariantDetails?.inventoryName || ""} - ${item.productVariantDetails?.contenance || ""}`.trim() ||
                "Nom inconnu";
            } catch (err) {
              console.warn(`Failed to fetch product name for variant ${item.productVariant}:`, err);
            }
            
            const articleData = {
              id: item.id,
              productVariant: item.productVariant,
              productName,
               unity: item.productVariantDetails?.unity || null,
              gamme: item.productVariantDetails?.gamme?.name || "N/A",
              prixAchat: item.productVariantDetails?.currentChannelPricings?.price
                ? (parseFloat(item.productVariantDetails.currentChannelPricings.price) / 100).toFixed(2)
                : "N/A",
              coef: parseFloat(parseFloat(item.coef).toFixed(8)).toString(),
              prixVenteHT: parseFloat(item.prixVenteHT).toFixed(2),
              tva: item.taxAmount ? `${parseFloat(item.taxAmount).toFixed(2)}%` : "N/A",
              prixTTC: item.prixTTC || calculateTTC(item.prixVenteHT, item.taxAmount || "20%"),
            };

            // Store original values for comparison
            originalPriceCoefs.value.set(item.id, {
              coef: articleData.coef,
              prixVenteHT: articleData.prixVenteHT
            });

            return articleData;
          })
        );
        priceCoefs.value = coefs;
        modifiedArticles.value.clear(); // Clear modifications when loading new data
      } catch (err) {
        priceCoefsError.value = "Erreur lors du chargement des coefficients de prix: " + (err.message || err);
        console.error("Fetch error:", err);
      } finally {
        priceCoefsLoading.value = false;
      }
    };

    const calculateTTC = (prixVenteHT, taxAmount) => {
      const ht = parseFloat(prixVenteHT) || 0;
      const tvaRate = parseFloat(taxAmount) / 100 || 0.2;
      return (ht * (1 + tvaRate)).toFixed(2);
    };

    // Check if article is modified
    const isArticleModified = (articleId) => {
      return modifiedArticles.value.has(articleId);
    };

    // Handle article input changes
    const onArticleInput = (articleId, field) => {
      const article = priceCoefs.value.find(a => a.id === articleId);
      if (!article) return;

      if (field === 'coef' && typeof article.coef === 'string') {
        article.coef = article.coef.replace(',', '.');
      } else if (field === 'prixVenteHT' && typeof article.prixVenteHT === 'string') {
        article.prixVenteHT = article.prixVenteHT.replace(',', '.');
      }

      // Update the other field based on which one was changed
      if (field === 'coef') {
        updatePriceTTCFromId(articleId);
      } else if (field === 'prixVenteHT') {
        updatePriceFromHTFromId(articleId);
      }

      // Check if the article is modified
      const original = originalPriceCoefs.value.get(articleId);
      if (original && (
        article.coef !== original.coef || 
        article.prixVenteHT !== original.prixVenteHT
      )) {
        modifiedArticles.value.add(articleId);
      } else {
        modifiedArticles.value.delete(articleId);
      }
    };

    const updatePriceTTCFromId = (articleId) => {
      const article = priceCoefs.value.find(a => a.id === articleId);
      if (!article) return;

      const prixAchat = parseFloat(article.prixAchat) || 0;
      const coef = parseFloat(article.coef) || 0;
      const tva = parseFloat(article.tva) || 20;

      if (prixAchat && coef) {
        article.prixVenteHT = (prixAchat * coef).toFixed(2);
      } else {
        article.prixVenteHT = "0.00";
      }

      article.prixTTC = calculateTTC(article.prixVenteHT, tva);
    };

    const updatePriceFromHTFromId = (articleId) => {
      const article = priceCoefs.value.find(a => a.id === articleId);
      if (!article) return;

      const prixAchat = parseFloat(article.prixAchat) || 0;
      const prixVenteHT = parseFloat(article.prixVenteHT) || 0;
      const tva = parseFloat(article.tva) || 20;

      if (prixAchat && prixVenteHT) {
        article.coef = parseFloat((prixVenteHT / prixAchat).toFixed(8)).toString();
      } else {
        article.coef = "0";
      }

      article.prixTTC = calculateTTC(prixVenteHT, tva);
    };

    // Legacy methods for individual row updates (keep for compatibility)
    const updatePriceTTC = (filteredIndex) => {
      const filteredArticle = filteredAndSortedPriceCoefs.value[filteredIndex];
      if (!filteredArticle) return;
      onArticleInput(filteredArticle.id, 'coef');
    };

    const updatePriceFromHT = (filteredIndex) => {
      const filteredArticle = filteredAndSortedPriceCoefs.value[filteredIndex];
      if (!filteredArticle) return;
      onArticleInput(filteredArticle.id, 'prixVenteHT');
    };

    const onGammeChange = () => {
      selectedSousGamme.value = ""; // Reset sous-gamme when gamme changes
      
      if (selectedGamme.value) {
        const selectedGammeObj = availableGammes.value.find(gamme => {
          const name = gamme._custom?.value?.name || gamme.name;
          return name === selectedGamme.value;
        });
        
        if (selectedGammeObj) {
          const code = selectedGammeObj._custom?.value?.code || selectedGammeObj.code;
          fetchPriceCoefs(code);
        }
      } else {
        // If no gamme selected, fetch all products
        fetchPriceCoefs();
      }
    };

    const onSousGammeChange = () => {
      if (selectedSousGamme.value) {
        const selectedSousGammeObj = availableSousGammes.value.find(sousGamme => {
          const name = sousGamme._custom?.value?.name || sousGamme.name;
          return name === selectedSousGamme.value;
        });
        
        if (selectedSousGammeObj) {
          const code = selectedSousGammeObj._custom?.value?.code || selectedSousGammeObj.code;
          fetchPriceCoefs(code);
        }
      } else {
        // If no sous-gamme selected, fetch products from the selected gamme
        onGammeChange();
      }
    };

    // Sorting functionality
    const toggleSortArticles = () => {
      if (!sortActive.value) {
        // First click - activate sorting with default ascending order
        sortActive.value = true;
        sortAscending.value = true;
      } else if (sortAscending.value) {
        // Second click - switch to descending
        sortAscending.value = false;
      } else {
        // Third click - deactivate sorting
        sortActive.value = false;
      }
    };

    const saveArticlePrice = async (filteredIndex) => {
      const filteredArticle = filteredAndSortedPriceCoefs.value[filteredIndex];
      const realIndex = priceCoefs.value.findIndex(article => article.id === filteredArticle.id);
      
      if (realIndex === -1) {
        toast.error("Article non trouvé dans la liste complète");
        return;
      }

      if (isChecked.value) {
        selectedArticleIndex.value = realIndex;
        showConfirmModal.value = true;
      } else {
        await performSaveArticlePrice(realIndex);
      }
    };

    const performSaveArticlePrice = async (realIndex) => {
      const article = priceCoefs.value[realIndex];
      savingSingle.value.add(article.id);
      saveError.value = null;
      
      try {
        const payload = {
          coef: parseFloat(article.coef).toFixed(8),
          prixVenteHT: parseFloat(article.prixVenteHT).toFixed(2),
        };
        await updateProductVariantPriceCoef(article.id, payload);
        
        // Update original values after successful save
        originalPriceCoefs.value.set(article.id, {
          coef: article.coef,
          prixVenteHT: article.prixVenteHT
        });
        
        // Remove from modified articles
        modifiedArticles.value.delete(article.id);
        
        priceCoefs.value[realIndex].prixTTC = calculateTTC(article.prixVenteHT, article.tva);
        toast.success(`Prix de l'article "${article.productName}" mis à jour avec succès !`);
      } catch (error) {
        saveError.value = "Erreur lors de l'enregistrement du prix: " + (error.message || error);
        toast.error(saveError.value);
      } finally {
        savingSingle.value.delete(article.id);
      }
    };

    // Multiple save functionality
    const saveMultipleArticles = async () => {
      if (modifiedArticles.value.size === 0) return;

      savingMultiple.value = true;
      saveError.value = null;

      try {
        const promises = Array.from(modifiedArticles.value).map(async (articleId) => {
          const article = priceCoefs.value.find(a => a.id === articleId);
          if (!article) return;

          const payload = {
            coef: parseFloat(article.coef).toFixed(8),
            prixVenteHT: parseFloat(article.prixVenteHT).toFixed(2),
          };
          
          const result = await updateProductVariantPriceCoef(articleId, payload);
          
          // Update original values after successful save
          originalPriceCoefs.value.set(articleId, {
            coef: article.coef,
            prixVenteHT: article.prixVenteHT
          });
          
          return result;
        });

        await Promise.all(promises);
        
        // Update TTC prices for all saved articles
        Array.from(modifiedArticles.value).forEach(articleId => {
          const article = priceCoefs.value.find(a => a.id === articleId);
          if (article) {
            article.prixTTC = calculateTTC(article.prixVenteHT, article.tva);
          }
        });

        const savedCount = modifiedArticles.value.size;
        modifiedArticles.value.clear(); // Clear all modifications after save
        
        toast.success(`${savedCount} article(s) mis à jour avec succès !`);
      } catch (error) {
        saveError.value = "Erreur lors de l'enregistrement des articles: " + (error.message || error);
        toast.error(saveError.value);
      } finally {
        savingMultiple.value = false;
      }
    };

    const confirmPriceChange = async () => {
      if (selectedArticleIndex.value !== null) {
        await performSaveArticlePrice(selectedArticleIndex.value);
        showConfirmModal.value = false;
        selectedArticleIndex.value = null;
      }
    };

    const handleRecommendedPriceToggle = () => {
      if (isChecked.value) {
        showRecommendedPriceModal.value = true;
      } else {
        isChecked.value = false;
      }
    };

    const confirmRecommendedPrice = async () => {
      await applyRecommended();
      showRecommendedPriceModal.value = false;
    };

    const closeRecommendedPriceModal = () => {
      isChecked.value = false;
      showRecommendedPriceModal.value = false;
    };

    const applyRecommended = async () => {
      saving.value = true;
      saveError.value = null;
      try {
        const subscriptionId = registerStore.VeterinaireData.hasSubscription.id;
        if (!subscriptionId) {
          throw new Error("Customer ID not found");
        }
        await applyRecommendedPrices(subscriptionId);
        toast.success("Prix de revente conseillés appliqués avec succès !");
        await fetchPriceCoefs();
      } catch (error) {
        saveError.value = "Erreur lors de l'application des prix conseillés: " + (error.message || error);
        toast.error(saveError.value);
      } finally {
        saving.value = false;
      }
    };

    const saveGammes = async () => {
      saving.value = true;
      saveError.value = null;
      try {
        const customerId = registerStore.VeterinaireInfo.customer_infos?.id || registerStore.user.id;
        const subscriptionId = registerStore.VeterinaireData.hasSubscription.id;
        if (!customerId) {
          throw new Error("Customer ID not found");
        }

        const GammeEnVente = gammes.value
          .filter(gamme => {
            const name = gamme._custom?.value?.name || gamme.name;
            return name && selected.value.includes(name);
          })
          .map(gamme => `/api/v2/shop/taxons/${gamme._custom?.value?.code || gamme.code}`)
          .filter(Boolean);

        const payload = {
          GammeEnVente,
        };

        const response = await updateVeterinaireSubscription(subscriptionId, payload);
        if (response) {
          await registerStore.fetchVeterinaire(true);
          await fetchPriceCoefs();
          toast.success("Gammes en vente mises à jour avec succès !");
        } else {
          saveError.value = "Erreur lors de l'enregistrement des gammes";
          toast.error(saveError.value);
        }
      } catch (error) {
        saveError.value = "Erreur lors de l'enregistrement des gammes: " + (error.message || error);
        toast.error(saveError.value);
      } finally {
        saving.value = false;
      }
    };

    const formatUnity = unity => {
        const match = unity?.match(/^(\d+)u$/i);
        return match ? `${match[1]}` : ''; 
      };

    const downloadExcel = async () => {
      try {
        if (!priceCoefs.value || priceCoefs.value.length === 0) {
          toast.error("Aucune donnée disponible pour le téléchargement.");
          return;
        }

        const headers = [
          "Articles",
          "Prix d'achat",
          "Coef de marge",
          "Prix de vente H.T",
          "TVA",
          "Prix de vente TTC",
        ];

        const data = [
          headers,
          ...priceCoefs.value.map(article => [
            article.productName || "N/A",
            article.prixAchat || "N/A",
            article.coef || "0.00",
            article.prixVenteHT || "0.00",
            article.tva || "N/A",
            article.prixTTC || "0.00",
          ]),
        ];

        const ws = XLSX.utils.aoa_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Tarifs");

        XLSX.writeFile(wb, "tarifs_catalogue.xlsx");
        toast.success("Téléchargement du fichier Excel réussi !");
      } catch (error) {
        toast.error("Erreur lors de la génération du fichier Excel : " + (error.message || error));
        console.error("Excel generation error:", error);
      }
    };

    // Fetch price coefficients after component is mounted
    onMounted(() => {
      fetchPriceCoefs();
      fetchNotifications();
    });

    return {
      notif,
      gammes,
      loading,
      error,
      registerLoading,
      registerError,
      saving,
      saveError,
      selected,
      isChecked,
      priceCoefs,
      priceCoefsLoading,
      priceCoefsError,
      saveGammes,
      saveArticlePrice,
      updatePriceTTC,
      updatePriceFromHT,
      priceTable,
      downloadExcel,
      confirmPriceChange,
      showConfirmModal,
      showRecommendedPriceModal,
      confirmRecommendedPrice,
      closeRecommendedPriceModal,
      handleRecommendedPriceToggle,
      selectedGamme,
      selectedSousGamme,
      searchQuery,
      filteredAndSortedPriceCoefs,
      initializationComplete,
      availableGammes,
      availableSousGammes,
      onGammeChange,
      onSousGammeChange,
      // Sorting functionality
      sortAscending,
      sortActive,
      toggleSortArticles,
      getSortTooltip,
      // Modified articles functionality
      hasModifiedArticles,
      modifiedArticlesCount,
      isArticleModified,
      onArticleInput,
      savingMultiple,
      savingSingle,
      saveMultipleArticles,
      formatUnity,
      handleConfirmNotification,
      showNewProductsModal,
      productNotifications,
      fetchNotifications
    };
  },
};
</script>

<style>
  .label-text {
    font-size: 12px;
  }

  .btn-notif-new {
    border: 1px solid #f37021;
    background: transparent;
    border-radius: 50px;
    padding: 10px 30px;
    color: #f37021;
    font-weight: 600;
    transition: all 0.3s ease;
    line-height: 1.2;
    font-size: 15px;
  }
  
  .btn-notif-new:hover {
    background-color: rgba(243, 112, 33, 0.05);
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(243, 112, 33, 0.15);
  }

  .btn-notif-new i {
    animation: pulse-bell 2s infinite;
  }

  @keyframes pulse-bell {
    0% { transform: scale(1); }
    10% { transform: scale(1.2) rotate(10deg); }
    20% { transform: scale(1.2) rotate(-10deg); }
    30% { transform: scale(1.2) rotate(10deg); }
    40% { transform: scale(1.2) rotate(-10deg); }
    50% { transform: scale(1); }
    100% { transform: scale(1); }
  }

  .check-button input:disabled + .label-text,
  .check-button input:disabled ~ .check-icon {
    cursor: not-allowed;
  }

  .input-form {
    min-width: 200px;
  }

  .spinner-circle-small {
    display: inline-block;
    width: 14px;
    height: 14px;
    border: 2px solid #ccc;
    border-top-color: transparent;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }

  .spinner-circle-small.white {
    border-color: white;
    border-top-color: transparent;
  }

  /* Enhanced Sortable Header Styles */
  .table-header-with-sort {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .header-title {
    font-weight: bold;
  }

  .btn-sort {
    display: flex;
    align-items: center;
    gap: 4px;
    background: none;
    border: 1px solid #e9ecef;
    border-radius: 4px;
    padding: 4px 8px;
    cursor: pointer;
    color: #6c757d;
    transition: all 0.3s ease;
    font-size: 12px;
  }

  .btn-sort:hover {
    background-color: #f8f9fa;
    border-color: #fd7e14;
    color: #fd7e14;
  }

  .btn-sort:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(253, 126, 20, 0.25);
  }

  .btn-sort.sort-active {
    background-color: rgba(253, 126, 20, 0.1);
    border-color: #fd7e14;
    color: #fd7e14;
  }

  .btn-sort.sort-asc .sort-icon {
    transform: translateY(-1px);
  }

  .btn-sort.sort-desc .sort-icon {
    transform: translateY(1px);
  }

  .sort-icon {
    font-size: 14px;
    transition: all 0.3s ease;
  }

  .sort-order {
    font-size: 11px;
    font-weight: 600;
  }

  /* Article name cell styling */
  .article-name-cell {
    font-weight: 500;
    color: #333;
  }

  /* Animation for sort transition */
  .table tbody tr {
    transition: all 0.3s ease;
  }

  /* Modified article styling */
  .table tbody tr.modified {
    background-color: rgba(255, 193, 7, 0.05);
    border-left: 3px solid #ffc107;
  }

  .modified-indicator {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffc107;
  }

  .modified-indicator i {
    font-size: 8px;
  }

  /* Sticky Save Multiple Button */
  .sticky-save-multiple {
    position: fixed;
    bottom: 20px;
    right: 20px;
    z-index: 1000;
    opacity: 0;
    transform: translateY(100px);
    transition: all 0.3s ease;
  }

  .sticky-save-multiple.has-changes {
    opacity: 1;
    transform: translateY(0);
  }

  .btn-orange-sticky {
    background: linear-gradient(135deg, #fd7e14, #e55a00);
    color: white;
    border: none;
    padding: 12px 20px;
    border-radius: 50px;
    font-weight: 600;
    box-shadow: 0 4px 15px rgba(253, 126, 20, 0.3);
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    min-width: 320px;
    justify-content: center;
  }

  .btn-orange-sticky:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(253, 126, 20, 0.4);
  }

  .btn-orange-sticky:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
    background: #6c757d;
  }

  .w-5 {
    width: 5%;
  }

  /* Individual save button states */
  .btn-save:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }



  /* Responsive design */
  @media (max-width: 768px) {
    .btn-sort {
      padding: 3px 6px;
      font-size: 11px;
    }
    
    .sort-order {
      font-size: 10px;
    }

    .sticky-save-multiple {
      bottom: 10px;
      right: 10px;
      left: 10px;
    }
    
    .btn-orange-sticky {
      min-width: auto;
      width: 100%;
      padding: 10px 16px;
      font-size: 14px;
    }
  }

  /* Ensure the spinner is properly aligned */
  .btn-orange-sticky .spinner-circle-small {
    margin-right: 8px;
  }
  .check-button input:disabled ~ .check-icon {
    cursor: not-allowed;
  }

  .input-form {
    min-width: 200px;
  }

  .spinner-circle-small {
    display: inline-block;
    width: 14px;
    height: 14px;
    border: 2px solid #ccc;
    border-top-color: transparent;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }

  .spinner-circle-small.white {
    border-color: white;
    border-top-color: transparent;
  }

  /* Enhanced Sortable Header Styles */
  .table-header-with-sort {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .header-title {
    font-weight: bold;
  }

  .btn-sort {
    display: flex;
    align-items: center;
    gap: 4px;
    background: none;
    border: 1px solid #e9ecef;
    border-radius: 4px;
    padding: 4px 8px;
    cursor: pointer;
    color: #6c757d;
    transition: all 0.3s ease;
    font-size: 12px;
  }

  .btn-sort:hover {
    background-color: #f8f9fa;
    border-color: #fd7e14;
    color: #fd7e14;
  }

  .btn-sort:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(253, 126, 20, 0.25);
  }

  .btn-sort.sort-active {
    background-color: rgba(253, 126, 20, 0.1);
    border-color: #fd7e14;
    color: #fd7e14;
  }

  .btn-sort.sort-asc .sort-icon {
    transform: translateY(-1px);
  }

  .btn-sort.sort-desc .sort-icon {
    transform: translateY(1px);
  }

  .sort-icon {
    font-size: 14px;
    transition: all 0.3s ease;
  }

  .sort-order {
    font-size: 11px;
    font-weight: 600;
  }

  /* Article name cell styling */
  .article-name-cell {
    font-weight: 500;
    color: #333;
  }

  /* Animation for sort transition */
  .table tbody tr {
    transition: all 0.3s ease;
  }

  /* Modified article styling */
  .table tbody tr.modified {
    background-color: rgba(255, 193, 7, 0.05);
    border-left: 3px solid #ffc107;
  }

  .modified-indicator {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffc107;
  }

  .modified-indicator i {
    font-size: 8px;
  }

  /* Sticky Save Multiple Button */
  .sticky-save-multiple {
    position: fixed;
    bottom: 20px;
    right: 20px;
    z-index: 1000;
    opacity: 0;
    transform: translateY(100px);
    transition: all 0.3s ease;
  }

  .sticky-save-multiple.has-changes {
    opacity: 1;
    transform: translateY(0);
  }

  .btn-orange-sticky {
    background: linear-gradient(135deg, #fd7e14, #e55a00);
    color: white;
    border: none;
    padding: 12px 20px;
    border-radius: 50px;
    font-weight: 600;
    box-shadow: 0 4px 15px rgba(253, 126, 20, 0.3);
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    min-width: 320px;
    justify-content: center;
  }

  .btn-orange-sticky:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(253, 126, 20, 0.4);
  }

  .btn-orange-sticky:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
    background: #6c757d;
  }

  .w-5 {
    width: 5%;
  }

  /* Individual save button states */
  .btn-save:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }



  /* Responsive design */
  @media (max-width: 768px) {
    .btn-sort {
      padding: 3px 6px;
      font-size: 11px;
    }
    
    .sort-order {
      font-size: 10px;
    }

    .sticky-save-multiple {
      bottom: 10px;
      right: 10px;
      left: 10px;
    }
    
    .btn-orange-sticky {
      min-width: auto;
      width: 100%;
      padding: 10px 16px;
      font-size: 14px;
    }
  }

  /* Ensure the spinner is properly aligned */
  .btn-orange-sticky .spinner-circle-small {
    margin-right: 8px;
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
  .unity-badge {
    display: inline-block;
    background-color: #ec621a;
    color: white;
    padding: 2px 8px;
    border-radius: 12px;
    font-size: 11px;
    font-weight: 500;
    margin-left: 8px;
    text-transform: uppercase;
    min-width: 35px;
    text-align: center;
  }

  .small-x {
    font-size: 9px !important; 
    margin-right: 1px;
  }

  /* ===== RESPONSIVE STYLES ===== */

  /* Tablet (768px to 991px) */
  @media (max-width: 991px) {
    .content-dashboard h3 {
      font-size: 22px;
      margin-bottom: 20px;
    }

    .gamme-info.gamme-catalogue {
      width: 100%;
      margin-bottom: 20px;
    }

    .box-chart {
      margin-bottom: 20px;
    }

    .box-chart .d-flex.gap-0 {
      flex-direction: column;
      gap: 20px !important;
    }

    .check-block {
      flex-wrap: wrap;
      justify-content: flex-start;
      gap: 10px !important;
    }

    .check-button {
      font-size: 13px;
      padding: 10px 16px;
      transition: all 0.2s ease;
    }

    .btn-orange.w-15 {
      width: 100% !important;
      margin-top: 10px;
    }

    /* Filters section */
    .col-lg-12.d-flex.justify-content-between {
      flex-direction: column;
      gap: 20px;
    }

    .col-lg-12.d-flex.justify-content-between > .d-flex.gap-3 {
      flex-direction: column;
      width: 100%;
      gap: 15px !important;
    }

    .input-form {
      min-width: 100%;
      width: 100%;
    }

    /* Gamme info section */
    .gamme-info.w-50 {
      width: 100% !important;
      margin-bottom: 20px;
    }

    .gamme-info h3 {
      font-size: 19px;
      line-height: 1.4;
    }

    .gamme-info p {
      font-size: 14px;
      line-height: 1.6;
    }

    /* Table adjustments */
    .table-responsive {
      overflow-x: auto;
      -webkit-overflow-scrolling: touch;
      border-radius: 8px;
      box-shadow: 0 2px 8px rgba(0,0,0,0.05);
    }

    .table th,
    .table td {
      font-size: 13px;
      padding: 12px 10px;
    }

    .table .w-25 {
      min-width: 200px;
    }

    .table .w-15 {
      min-width: 110px;
    }

    /* Sticky button */
    .btn-orange-sticky {
      min-width: 280px;
      padding: 12px 20px;
      font-size: 14px;
    }
  }

  /* Mobile (max-width: 767px) */
  @media (max-width: 767px) {
    .content-dashboard {
      padding: 8px;
    }

    .content-dashboard h3 {
      font-size: 20px;
      margin-bottom: 16px;
      line-height: 1.3;
    }

    .box-chart {
      padding: 16px !important;
      margin-bottom: 16px;
      border-radius: 12px;
    }

    /* Gamme section */
    .gamme-info.gamme-catalogue h3 {
      font-size: 17px;
      margin-bottom: 12px;
      line-height: 1.3;
    }

    .gamme-info.gamme-catalogue p {
      font-size: 13px;
      line-height: 1.5;
      margin-bottom: 12px;
    }

    .check-block {
      gap: 10px !important;
      margin-bottom: 12px;
    }

    .check-button {
      font-size: 12px;
      padding: 8px 12px;
      width: calc(50% - 5px);
      justify-content: center;
      min-height: 40px;
      display: flex;
      align-items: center;
      border-radius: 8px;
      transition: all 0.2s ease;
    }

    .check-button:active {
      transform: scale(0.98);
    }

    .check-button .label-text {
      font-size: 11px;
      text-align: center;
      line-height: 1.3;
    }

    .btn-orange {
      font-size: 14px;
      padding: 12px 18px;
      border-radius: 8px;
      min-height: 44px;
    }

    /* Filters */
    .input-form {
      margin-bottom: 12px;
    }

    .input-form label {
      font-size: 13px;
      margin-bottom: 8px;
      font-weight: 600;
    }

    .input-form .form-control {
      font-size: 14px;
      padding: 10px 14px;
      border-radius: 8px;
      min-height: 44px;
    }

    /* Gamme info section */
    .gamme-info h3.dark-color {
      font-size: 17px;
      margin-bottom: 12px;
      line-height: 1.3;
    }

    .gamme-info p.blue-color {
      font-size: 13px;
      line-height: 1.6;
      margin-bottom: 12px;
    }

    .check-input .check-button {
      width: 100%;
      padding: 12px 14px;
      min-height: 48px;
    }

    /* Table */
    .table-responsive {
      margin-top: 16px;
      border-radius: 8px;
      box-shadow: 0 2px 12px rgba(0,0,0,0.08);
    }

    .table {
      font-size: 12px;
      margin-bottom: 0;
    }

    .table th {
      font-size: 11px;
      padding: 10px 6px;
      white-space: nowrap;
      background-color: #f8f9fa;
      font-weight: 700;
    }

    .table td {
      padding: 10px 6px;
      font-size: 11px;
      vertical-align: middle;
    }

    .table .w-25 {
      min-width: 160px;
    }

    .table .w-15 {
      min-width: 90px;
    }

    .table .w-5 {
      width: 30px;
      min-width: 30px;
    }

    .table .form-control {
      font-size: 12px;
      padding: 6px 8px;
      border-radius: 6px;
      min-height: 36px;
    }

    .article-name-cell {
      font-size: 11px;
      line-height: 1.4;
      font-weight: 500;
    }

    .unity-badge {
      font-size: 9px;
      padding: 2px 6px;
      margin-left: 6px;
      border-radius: 10px;
    }

    .btn-save {
      padding: 6px 10px;
      font-size: 11px;
      border-radius: 6px;
      min-height: 36px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .btn-save i {
      font-size: 14px;
    }

    /* Table header sort button */
    .table-header-with-sort {
      flex-direction: row;
      align-items: center;
      gap: 8px;
    }

    .btn-sort {
      padding: 4px 8px;
      font-size: 10px;
      border-radius: 6px;
    }

    .sort-icon {
      font-size: 12px;
    }

    /* Sticky button */
    .sticky-save-multiple {
      bottom: 12px;
      right: 12px;
      left: 12px;
    }

    .btn-orange-sticky {
      min-width: auto;
      width: 100%;
      padding: 14px 18px;
      font-size: 14px;
      border-radius: 12px;
      box-shadow: 0 4px 20px rgba(253, 126, 20, 0.4);
    }

    /* Modals */
    .modal-dialog {
      margin: 12px;
    }

    .modal-content {
      padding: 12px;
      border-radius: 12px;
    }

    .modal-body {
      padding: 18px;
    }

    .modal-body h3,
    .modal-body h4 {
      font-size: 17px;
      margin-bottom: 12px;
    }

    .modal-body p {
      font-size: 13px;
      line-height: 1.6;
    }

    .modal-body .d-flex.gap-3 {
      flex-direction: column;
      gap: 12px !important;
    }

    .modal-body .btn {
      font-size: 14px;
      padding: 10px 16px;
      border-radius: 8px;
      min-height: 44px;
    }

    .modal-body .btn.w-30 {
      width: 100% !important;
    }
  }

  /* Very small mobile (max-width: 480px) */
  @media (max-width: 480px) {
    .content-dashboard {
      padding: 6px;
    }

    .content-dashboard h3 {
      font-size: 18px;
      margin-bottom: 14px;
    }

    .box-chart {
      padding: 14px !important;
      margin-bottom: 14px;
    }

    .gamme-info.gamme-catalogue h3 {
      font-size: 16px;
      margin-bottom: 10px;
    }

    .gamme-info.gamme-catalogue p {
      font-size: 12px;
      line-height: 1.5;
    }

    .check-block {
      gap: 8px !important;
    }

    .check-button {
      font-size: 11px;
      padding: 7px 10px;
      min-height: 38px;
    }

    .btn-orange {
      font-size: 13px;
      padding: 10px 16px;
      min-height: 42px;
    }

    /* Make table more compact but still usable */
    .table th,
    .table td {
      padding: 8px 4px;
      font-size: 10px;
    }

    .table .w-25 {
      min-width: 140px;
    }

    .table .w-15 {
      min-width: 75px;
    }

    .table .w-5 {
      width: 25px;
      min-width: 25px;
    }

    .table .form-control {
      font-size: 11px;
      padding: 5px 6px;
      min-height: 32px;
    }

    .article-name-cell {
      font-size: 10px;
      line-height: 1.3;
    }

    .unity-badge {
      font-size: 8px;
      padding: 1px 5px;
      margin-left: 4px;
    }

    .btn-save {
      padding: 5px 8px;
      min-height: 32px;
    }

    .btn-save i {
      font-size: 12px;
    }

    .btn-orange-sticky {
      padding: 12px 16px;
      font-size: 13px;
    }

    .modified-indicator i {
      font-size: 6px;
    }

    /* Improve input form spacing */
    .input-form {
      margin-bottom: 10px;
    }

    .input-form .form-control {
      min-height: 40px;
    }
  }

</style>